import React, { useEffect } from 'react';

import { useMediaPlayer } from '../../../MediaPlayerProvider';

/*
   This is the migration of the legacy logic.
   Probably we don't need it, because we don't save volume state.
   It's implemented just to be sure, that everything works as with JWPlayer
   NOTE: it's candidate to be removed
 */
export const DefaultVolumeLevel: React.FC = () => {
  const { player } = useMediaPlayer();

  useEffect(() => {
    if (player !== null) {
      player.muted(false);
      const volume = player.volume();
      if (volume < 0.25) {
        player.volume(0.25);
      }
    }
  }, [player]);
  return null;
};
